<template>
  <!-- Tilt on the whole device -->
  <div class="aspect-square">
    <div
      ref="deviceRef"
      :style="styleVars"
      class="device mx-auto border-gray-800 bg-gray-800 border-[14px] rounded-[2.5rem] aspect-[1/2] shadow-2xl cursor-pointer h-full overflow-hidden relative"
      @click="start"
    >
      <span class="shine" aria-hidden="true"></span>

      <img
        :src="src"
        alt="Mockup urządzenia z aplikacją"
        draggable="false"
        class="img block w-full h-full select-none object-cover border-gray-800"
        loading="lazy"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useTilt } from "@/composables/useTilt";

const { target: deviceRef, styleVars } = useTilt(10);
const run = ref(0);
const i = ref(0);

// swap between any images you want (add more if needed)
const images = ["/mockup-1-light.png", "/mockup-2-light.png"];

const src = computed(() => images[i.value % images.length]);

const start = () => {
  i.value = (i.value + 1) % images.length; // change image
  run.value++; // replay pop/shine
};
</script>

<style scoped>
.device {
  transform-style: preserve-3d;
  transform: perspective(900px) rotateX(var(--rx, 0deg)) rotateY(var(--ry, 0deg));
  transition: transform 0.18s cubic-bezier(0.2, 0.8, 0.2, 1);
}

.img {
  animation: pop 0.6s cubic-bezier(0.2, 0.9, 0.2, 1) both;
  filter: drop-shadow(0 10px 30px rgba(0, 0, 0, 0.28));
  will-change: transform, opacity, filter;
}

.shine {
  position: absolute;
  inset: -12% 0 -12% 0;
  background: linear-gradient(
    110deg,
    transparent 35%,
    rgba(255, 255, 255, 0.7) 50%,
    transparent 65%
  );
  transform: translateX(-120%);
  animation: shine 0.7s cubic-bezier(0.16, 1, 0.3, 1) 0.12s both;
  pointer-events: none;
  mix-blend-mode: screen;
}

@keyframes pop {
  0% {
    opacity: 0;
    transform: translateY(14px) scale(0.96) rotateX(6deg) rotateY(-6deg);
    filter: blur(4px);
  }
  60% {
    opacity: 1;
    transform: translateY(-1px) scale(1.015);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes shine {
  from {
    transform: translateX(-120%);
  }
  to {
    transform: translateX(140%);
  }
}

@media (prefers-reduced-motion: reduce) {
  .device {
    transform: none !important;
    transition: none !important;
  }
  .img,
  .shine {
    animation: none !important;
  }
}
</style>
